import { RadioGroup } from '@headlessui/react';

import { useFieldContext } from '../';

import { IconRadioButton } from './IconRadioButton';

export type IconButtonType = {
	icon: React.ReactElement | string;
	label?: string;
	value: number;
	activeClasses: string;
};

type IconRadioGroupProps = {
	IconRadioButtons: IconButtonType[];
	className?: string;
	label: string;
};

export const IconRadioGroupV2: React.FC<IconRadioGroupProps> = ({
	IconRadioButtons,
	className,
	label,
}) => {
	const field = useFieldContext<string>();
	const selected = IconRadioButtons.find((elm) => elm.value === Number(field.state.value));

	const onChange = (e: IconButtonType) => {
		field.handleChange(`${e.value}`);
	};

	return (
		<RadioGroup
			aria-labelledby={label}
			data-test-id={`radiobuttongroup`}
			onChange={(e: IconButtonType) => onChange(e)}
		>
			<RadioGroup.Label className='sr-only'>{label}</RadioGroup.Label>
			<div className={className}>
				{IconRadioButtons.map((button) => (
					<IconRadioButton
						key={button.label}
						button={button}
						checked={selected === button}
					/>
				))}
			</div>
		</RadioGroup>
	);
};
